export default __webpack_public_path__ + "static/media/logo3.624d4538.png";